import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query, SubscriptionWrapper} from 'react-apollo'
import {gql} from 'apollo-boost'
import {debounce} from 'lodash'
import {withRouter} from 'react-router-dom'
import 'react-table/react-table.css'

import AUSelectGenerator from '../auto_updaters/Select'

const AUSelectProjectStatuses = AUSelectGenerator('project_statuses', 'project_status_id description', 'project_status_id', ['description'])

const QUERY = gql`query filter_projects(
    $project_id: String, 
    $name: String, 
    $project_status_id: String, 
    $project_director_id: String, 
    $project_manager_id: String,
    $project_clients: String
    ){
  filter_projects(project_id: $project_id, 
                    name: $name, 
                    project_status_id: $project_status_id, 
                    project_director_id: $project_director_id, 
                    project_manager_id: $project_manager_id,
                    project_clients: $project_clients){
    project_id_prefix
    project_id
    name
    description

    project_status{
        description
    }
    project_director{
      user_id
      first_name
      last_name
    }
    project_manager{
      user_id
      first_name
      last_name
    }
    
    project_associated_disciplines{
      project_discipline_id
      description
    }
    total_budget
    total_fees
    total_supplier_invoiced
    total_hours
    
    project_clients{
      client{
        client_id
        name
      }
      address{
        address_id
        abode_name_no
        building_no
        street
        city
        postcode
      }
    }
    project_addresses{
      address_id
      abode_name_no
      building_no
      street
      city
      postcode
    }
  }
}`


class ProjectsList extends Component{


    render(){
        return (<ReactTable
            data={this.props.projects}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "Project ID",
                    id: 'project_id',
                    accessor: 'project_id'
                },
                {
                    Header: "Name",
                    id: 'name',
                    accessor: 'name'
                },
                {
                    Header: "Status",
                    id: 'project_status_id',
                    accessor: "project_status.description",
                    Filter: ({filter, onChange}) => {
                        return <AUSelectProjectStatuses className="form-control-sm" value={(filter) ? filter.value: null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Clients",
                    id: "project_clients",
                    accessor: "project_clients",
                    filterable: true,
                    Cell: row => (
                        <div>
                            {row.value.map(({client}) => <div>{client.name}</div>)}
                        </div>
                    )
                },
                {
                    Header: "Budget",
                    id: 'total_budget',
                    accessor: ({total_budget}) => Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'GBP'
                    }).format(total_budget) || 0,
                    filterable: false
                },
                {
                    Header: "Budget Used",
                    id: 'total_fees',
                    accessor: ({total_fees, total_supplier_invoiced}) => Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'GBP'
                    }).format(total_fees + total_supplier_invoiced) || 0,
                    filterable: false
                },
                {
                    Header: "Hours Worked",
                    id: "total_hours",
                    accessor: "total_hours",
                    filterable: false
                }

            ]}
            className="-striped -highlight"
            onFetchData={debounce((state, instance) => this.props.onFetchData(state, instance), 500)} // Request new data when things change
            filterable
            manual
            showPagination={false}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        console.log(rowInfo)
                        //Router.push({pathname: '/reports/projects/analytics', query: { project_id: rowInfo.original.project_id }})
                        this.props.history.push(`/reports/projects/${rowInfo.original.project_id}`)
                    }
                }
            }}
        />)
    }
}

ProjectsList = withRouter(ProjectsList)

export default class ProjectsTable extends Component{

    state = {
        project_id: '',
        name: '',
        project_status_id: null,
        project_clients: null
    }

    fetchData = (state, instance) => {
        let filters = state.columns.reduce((carry, column) => {
            if(column.hasOwnProperty('id')) {
                const filterValue = state.filtered.find(({id}) => id === column.id)
                carry[column.id] = (filterValue) ? filterValue.value : ''
            }
            return carry
        }, {})

        this.setState(Object.assign({}, filters))
    }

    render(){
        const {project_id, name, project_status_id, project_clients} = this.state
        return(<Query query={QUERY} variables={{project_id, name, project_status_id, project_clients}} fetchPolicy="network-only">
            {(result) => {

                const projects = (result.data && result.data.filter_projects) ? result.data.filter_projects: []

                return(
                    <ProjectsList loading={result.loading} projects={projects} onFetchData={this.fetchData}/>

                )
            }}
        </Query>)
    }

}